import { ReactNode } from "react";
import { valueOrNa } from "../../utils/string";

export type TListTOClass = {
  label: string;
  value: string;
  className: string;
};

type Props = {
  list: TListTOClass[];
  value: string;
  isNormalText?: true;
  className?: string;
  label?: string;
  statusChild?: ReactNode;
};

export default function StatusItem({
  list,
  value,
  className = "",
  label,
  statusChild,
}: Props) {
  const item = list.find((el) => el.value === value);
  const val = label || item?.label || value;

  return (
    <span
      className={`${value ? `status ${item?.className}` : ""} ${className}`}
    >
      {valueOrNa(val)} {statusChild}
    </span>
  );
}
